var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({background: _vm.$vuetify.theme.themes.light.background})},[_c('Navbar'),_c('v-main',{staticClass:"mx-4 mb-4"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }